/**
 * Input directive for Edit functionality
 * Created by
 * @author <yunishev@sotal.tv> Art Yunishev
 * on 30.01.2015-19:42
 */

lmApp.
  directive('lmInputField', ['$timeout', function ($timeout) {
    return {
      restrict: 'E',
      replace: true,
      scope: {
        id: '@',
        type: '@',
        icon: '@',
        endlineIcon: '@',
        label: '@',
        placeholder: '@',
        ngModel: '=',
        ngModelOptions: '=?',
        ngDisabled: '=?',
        ngReadonly: '=?',
        error: '@',
        errorFn: '=?',
        warning: '@',
        warningFn: '=?',
        success: '@',
        successFn: '=?',
        isLong: '=?',
        isBordesless: '=?',
        onKeyPress: '&',
        onFocus: '&',
        onBlur: '&',
        isFocused: '@',
        isInline: '@',
        mt0: '@'
      },
      link: function (scope, element, attrs) {
        if (!scope.id) scope.timestamp = Date.now();

        attrs.$observe('error', function (value) {
          scope.error = value;
        });
        attrs.$observe('warning', function (value) {
          scope.warning = value;
        });
        attrs.$observe('success', function (value) {
          scope.success = value;
        });

        scope._input_ = element.find('input');

        scope._onFocus = function () {
          $timeout(function () {
            scope.isFocused = true;
          });
          scope.onFocus();
        };

        scope._input_.bind('focus', scope._onFocus);

        scope._onBlur = function () {
          $timeout(function () {
            scope.isFocused = false
          });
          scope.onBlur();
        };

        scope._input_.bind('blur', scope._onBlur);

        scope._onKeyPress = function (event) {
          if (scope.onKeyPress) scope.onKeyPress();

          if (event && event.which != 9 /*TAB*/) {
            if (!_.isUndefined(scope.errorFn)) {
              scope.errorFn = false;
            }
            if (!_.isUndefined(scope.warningFn)) {
              scope.warningFn = false;
            }
            if (!_.isUndefined(scope.successFn)) {
              scope.successFn = false;
            }
          }
        };

        scope._input_.bind('keydown', scope._onKeyPress);

        if (scope.isFocused) scope.timeoutFocused = $timeout(function () {
          scope._input_.focus();
        }, 450);

        scope.focusMe = function () {
          scope._input_.focus();
        };

        scope._input_.on('$destroy', function () {
          if (scope.timeoutFocused) $timeout.cancel(scope.timeoutFocused);
          scope._input_.unbind('focus', scope._onFocus);
          scope._input_.unbind('blur', scope._onBlur);
          scope._input_.unbind('keydown', scope._onKeyPress);
          scope.$destroy();
        });

      },
      templateUrl: 'lm-input-field/input-field.tpl.html'
    };
  }]);
